import gql from 'graphql-tag';

const GET_SERVICE_RUN_ROSTER_PICKERS = gql`
	query getServiceRunRosterPickers($date: String!) {
		getServiceRunRosterPickers(date: $date) {
			employeeId
			employeeName
			workTenantName
			shifts {
				id
				startMinutes
				endMinutes
				area
				areaLabel
			}
			clockSummary {
				clockedInAt
				clockedOutAt
				workedMinutes
				isClockedIn
				latestClockedInAt
				totalWorkedMinutes
			}
			user {
				id
				firstname
				lastname
			}
		}
	}
`;

export default GET_SERVICE_RUN_ROSTER_PICKERS;
